import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { enablePartnerLogosSlider } from 'App/app/ui';
import { orderPartners, reservationPartners, LUBJEpartners } from './partners';

const restaurantsByType = {
  orders: orderPartners,
  reservations: reservationPartners,
  lubje: LUBJEpartners,
};

const PartnerLogos = ({ text, type }) => {
  useEffect(enablePartnerLogosSlider, []);

  const restaurants = restaurantsByType[type] || restaurantsByType.orders;
  return <section className="home-partners">
    <h4 className="home-title home-title--smaller mt-4 mb-5">{text}</h4>
    <div className="partner-logos">
      {
        restaurants.map(item => <img
          key={item.src}
          src={item.src}
          alt={`Logo restauracji ${item.restaurantName}`}
          className={item.addonClass || ''}
           />)
      }
    </div>
  </section>;
};

PartnerLogos.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['orders', 'reservations', 'lubje']),
};

PartnerLogos.defaultProps = {
  text: 'Oni już przyjmują zamówienia online',
  type: 'orders',
};

export default PartnerLogos;